import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { UserPermissions } from './dto/user-permissions.dto'
import type { User } from './user'
import type { UserNotifications } from './user-notification'

export class UsersRepository extends BaseRepository<User> {
    private configS
    constructor(
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/' + 'users', token, cache)
        this.configS = config
    }
    async getManager() {
        if (!window.store.company.managerId) return null
        const url = this.configS.userApiUrl + '/managers/' + window.store.company.managerId + '/public?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async updatePermissions(userId: string, dto: any) {
        const { json, statusCode, message } = await this.request.patch(
            this.configS.userApiUrl + '/users/' + userId + '/permissions/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getPermissions(userId: string): Promise<UserPermissions> {
        const { json, statusCode, message } = await this.request.get(
            this.configS.userApiUrl + '/users/' + userId + '/permissions/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async upsertFCMToken(token: string) {
        const { json, statusCode, message } = await this.request.post(this.configS.userApiUrl + '/users/fcm?token=' + this.resolvedToken, { token })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async upsertNotifications(dto: UserNotifications) {
        const { json, statusCode, message } = await this.request.post(this.configS.userApiUrl + '/users/notifications?token=' + this.resolvedToken, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
